import { SET_MOBILE_MODE } from '../../actionConstants';

export const setIsMobileScreen = (dispatch, isMobileScreen) =>
  dispatch({ type: SET_MOBILE_MODE, isMobileScreen });
